var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplace = function SvgReplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.5s.1-.392 3.02-3.31a7.475 7.475 0 0 1 12.574 3.624M1 7.5V4.178M1 7.5h3.322M17.5 11.438s.01.403-2.91 3.322a7.475 7.475 0 0 1-12.574-3.624m15.484.302v3.322m0-3.322h-3.322",
    stroke: "#111927",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
export default SvgReplace;